import { render, staticRenderFns } from "./JingJiaDetail.vue?vue&type=template&id=14d05d8c&scoped=true"
import script from "./JingJiaDetail.vue?vue&type=script&lang=js"
export * from "./JingJiaDetail.vue?vue&type=script&lang=js"
import style0 from "./JingJiaDetail.vue?vue&type=style&index=0&id=14d05d8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d05d8c",
  null
  
)

export default component.exports